"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Wrapper = styled_components_1.default.div `
  .MuiAlert-root {
    background-color: #fff;
    padding: 16px 0;
  }

  .MuiAlert-icon {
    align-items: center;
    color: #000;
  }
`;
const PricingWrapper = styled_components_1.default.div `
  background-color: #fafafa;
  width: 100%;
  padding: 16px;
  border-radius: 4px;
`;
const Header = styled_components_1.default.div `
  font-size: 18px;
  padding-bottom: 10px;
  font-weight: bold;
  border-bottom: 1px solid #eae9ea;
  display: flex;
  justify-content: space-between;
`;
const Card = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid #eae9ea;
  padding: 12px 0;

  .item-name {
    width: calc(100% - 80px);

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @supports (-webkit-line-clamp: 2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .price {
    min-width: 80px;
    text-align: right;
    font-size: 14px;
  }

  .comment {
    width: 100%;
    color: #656b80;
    font-size: 12px;
  }
`;
const PriceBreakdown = styled_components_1.default.div `
  margin-top: 12px;
  div {
    display: flex;
    justify-content: space-between;
    color: #656b80;
    font-size: 14px;
    margin-bottom: 2px;

    .total {
      font-weight: 500;
      color: #000;
      font-size: 16px;
    }

    .value {
      min-width: 100px;
      text-align: right;
    }
  }
`;
const BalanceDetails = ({ balanceData }) => {
    if (!balanceData) {
        return null;
    }
    const cards = balanceData.lineItems.map((item) => (react_1.default.createElement(Card, { key: `${item.name}` },
        react_1.default.createElement("span", { className: "item-name" }, item.name),
        react_1.default.createElement("span", { className: "price" }, item.total),
        item.comment && react_1.default.createElement("span", { className: "comment" }, item.comment))));
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(PricingWrapper, null,
            react_1.default.createElement(Header, null,
                react_1.default.createElement("span", null, balanceData.texts.balanceLabel),
                react_1.default.createElement("span", null, balanceData.total)),
            cards,
            react_1.default.createElement(PriceBreakdown, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null, balanceData.texts.detailsScreenSubTotalLabel),
                    react_1.default.createElement("span", { className: "value" }, balanceData.subTotal)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "total" }, balanceData.texts.detailsScreenTotalLabel),
                    react_1.default.createElement("span", { className: "total value" }, balanceData.total)))),
        react_1.default.createElement(Alert_1.default, { severity: "info" }, balanceData.texts.detailsScreenHint)));
};
exports.default = BalanceDetails;
